/**
 * Users
 */

// React
import React, {FunctionComponent, useContext, useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';

// Components
import Pagination from '@material-ui/lab/Pagination';
import List from './components/variantList';
import Details from '../components/detail';
import ReportList from './components/reportList';

// UI
import {
  Card,
  CardContent,
  Typography,
  Paper,
  CircularProgress,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Box,
  Tab,
  Tabs,
  IconButton,
} from '@material-ui/core';

// Helper
import {removeEmptyValueObject, flattenObject} from '../../../utils/helpers';
import handleError from '../../../utils/handleError';

// Type
import {Props} from '.././interfaces';
import {GetSkuInventoryFlowRequestBuilder} from 'client-sdk/src/skus/skus';
import Client from 'client-sdk/src/client';
import classes from '../product.module.scss';
import RonadIcons from '../../../components/iconComponent';

const ProductsMobile: FunctionComponent<Props> = (
  props: Props
): React.ReactElement => {
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 10,
  } as any);
  const urlParams = useParams();

  const [reportList, setReportList] = useState<any>(null);
  const [inventoryFilters, setInventoryFilters] = useState({
    page: 0,
    size: 10,
  } as any);
  const [value, setValue] = useState(0);
  const [reportFilters, setReportFilters] = useState<any>({
    page: 0,
    size: 10,
  });

  const token = localStorage.getItem('token') || '';

  const handleGetParcelInventory = (id: number) => {
    setInventoryFilters((prevState: Record<string, any>) => ({
      ...prevState,
      'parcelId.equals': id,
    }));
    getParcelInventoryRequest({'parcelId.equals': id});
  };
  const getParcelInventoryRequest = (arg: Record<string, any>) => {
    props.getParcelInventoryItems({...inventoryFilters, ...arg});
  };

  useEffect(() => {
    getProduct();
    getProductVariants();
    fetchReportList(urlParams.id);
  }, [filtersValues]);

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({...filtersValues, page: page - 1});
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{value: unknown}>) => {
    setFiltersValues({...filtersValues, page: 0, size: event.target.value});
  };

  const fetchReportList = async (id: number, args?: Record<string, any>) => {
    try {
      const request = new GetSkuInventoryFlowRequestBuilder()
        .id(id)
        .params({
          ...removeEmptyValueObject(flattenObject(reportFilters)),
          ...args,
        })
        .build();
      const client = new Client(token);
      const {data} = await client.execute(request);
      setReportList(data);
    } catch (err) {
      handleError(err);
    }
  };

  const getProduct = () => {
    const {page, size} = filtersValues;
    const {partnerId} = props.match.params;
    props.productDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: {equals: partnerId},
      id: urlParams.id,
      page,
      size,
    });
  };

  const getProductVariants = () => {
    const {page, size} = filtersValues;
    const {partnerId} = props.match.params;
    props.productVariantsDispatch({
      ...removeEmptyValueObject(filtersValues),
      partnerId: {equals: partnerId},
      id: urlParams.id,
      page,
      size,
    });
  };
  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  };
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const TabPanel = (props: any) => {
    const {children, value, index, ...other} = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  };
  return (
    <div className={classes.root}>
      <Box className={classes.tabs}>
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="fullWidth"
        >
          <Tab label="اطلاعات کالا" {...a11yProps(0)} />
          <Tab label="لیست تنوع" {...a11yProps(1)} />
          <Tab label="ورود و خروج" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <Grid
        className={classes.topBox}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={0}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '83%',
            borderRadius: '0',
            paddingLeft: '10px',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2" className={classes.title}>
              {`جزیيات کالا`}
              {props.product.id}
            </Typography>
          </div>
          <Link to={`/edit-product/${props.product.id}`}>
            <button
              aria-label="edit"
              size="small"
              title="ویرایش"
              data-cy="edit"
              className={classes.editBtn}
            >
              <RonadIcons name='pencil' />
            </button>
          </Link>
        </Paper>
      </Grid>
      <TabPanel value={value} index={0}>
        <Details product={props.product} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Card className={classes.cardM} style={{padding: '0 !important'}}>
          <CardContent style={{padding: '0'}}>
            <Grid item xs={12}>
              {props.loading ? (
                <div className={classes.loading}>
                  <CircularProgress />
                </div>
              ) : (
                props.productsVariantsList && (
                  <List
                    data={props.productsVariantsList}
                    productName={props.product.name}
                  />
                )
              )}
            </Grid>
            <Grid
              md={12}
              container
              justifyContent="space-between"
              style={{marginTop: '10px', padding: '10px'}}
            >
              <Grid id="showFilter" item xs={6} sm={6}>
                {props.productsVariantsList && (
                  <FormControl
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                      {' '}
                      تعداد نمایش:
                    </div>
                    <Select
                      open={openSize}
                      onClose={handleCloseSelect}
                      className={classes.showCount}
                      onOpen={() => setOpenSize(true)}
                      value={filtersValues.size}
                      onChange={handleChangeSizePage}
                    >
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>
                  </FormControl>
                )}
              </Grid>
              <Grid container item xs={6} md={6} direction="row-reverse">
                {props.productsVariantsList && (
                  <Pagination
                    count={Math.ceil(
                      props.productVariantListCount / filtersValues.size
                    )}
                    color="secondary"
                    page={filtersValues.page + 1}
                    onChange={handleChangePage}
                  />
                )}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <ReportList
          data={reportList?.content}
          handleSelect={handleGetParcelInventory}
        />
      </TabPanel>
    </div>
  );
};

export default ProductsMobile;
